import React, { useMemo } from 'react';
import ConfigurationProvider from './service/Provider';
import ConfigureBapUI from './ConfigureBapUI';
import NotImplemented from '../NotImplemented';
import useAccessoriesData from './hooks/useAccessoriesData';
import useProtectionData from './hooks/useProtectionData';
import { ACURA_SITE_NAME, HONDA_SITE_NAME } from '../../utils/constants';
import { useAppName } from '../../utils/sitecoreContext';
import { variant1, variant2 } from './utils/constants';
const ConfigureBap = ({ rendering }) => {
    const appName = useAppName();
    let variant;
    switch (appName) {
        case HONDA_SITE_NAME:
            variant = variant1;
            break;
        case ACURA_SITE_NAME:
            variant = variant2;
            break;
        default:
    }
    const appNameConfig = useMemo(() => ({ variant }), [variant]);
    const accessoryData = useAccessoriesData();
    const protectionData = useProtectionData();
    if (!variant) {
        return React.createElement(NotImplemented, { name: "ConfigureBap" });
    }
    return (React.createElement(ConfigurationProvider, { appNameConfig: appNameConfig },
        React.createElement(ConfigureBapUI, { ...accessoryData, ...protectionData, componentName: rendering === null || rendering === void 0 ? void 0 : rendering.componentName })));
};
export default ConfigureBap;
